var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "full-screen-modal",
      attrs: {
        id: "notif-param-modal",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "ok-variant": "primary"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("div", { staticClass: "modal-header-content step4 w-100" }, [
                _c(
                  "div",
                  { staticClass: "notif-file-upload-container h-100" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center mb-2 d-md-none cursor-pointer",
                        on: { click: _vm.handleSubmit }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "header-button",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "36",
                              height: "36",
                              viewBox: "0 0 30 30",
                              fill: "none"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                opacity: "0.2",
                                d:
                                  "M26.25 15C26.25 17.225 25.5902 19.4001 24.354 21.2502C23.1179 23.1002 21.3609 24.5422 19.3052 25.3936C17.2495 26.2451 14.9875 26.4679 12.8052 26.0338C10.623 25.5998 8.61839 24.5283 7.04505 22.955C5.47171 21.3816 4.40025 19.3771 3.96617 17.1948C3.53209 15.0125 3.75487 12.7505 4.60636 10.6948C5.45785 8.63914 6.89979 6.88213 8.74984 5.64597C10.5999 4.4098 12.775 3.75 15 3.75C17.9837 3.75 20.8452 4.93526 22.955 7.04505C25.0647 9.15483 26.25 12.0163 26.25 15Z",
                                fill: "#EAEAEA"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M15 2.8125C12.5895 2.8125 10.2332 3.52728 8.22899 4.86646C6.22477 6.20564 4.66267 8.10907 3.74022 10.336C2.81778 12.563 2.57643 15.0135 3.04668 17.3777C3.51694 19.7418 4.67769 21.9134 6.38214 23.6179C8.08659 25.3223 10.2582 26.4831 12.6223 26.9533C14.9865 27.4236 17.437 27.1822 19.664 26.2598C21.8909 25.3373 23.7944 23.7752 25.1335 21.771C26.4727 19.7668 27.1875 17.4105 27.1875 15C27.1841 11.7687 25.899 8.67076 23.6141 6.3859C21.3292 4.10104 18.2313 2.81591 15 2.8125ZM15 25.3125C12.9604 25.3125 10.9666 24.7077 9.27069 23.5745C7.57481 22.4414 6.25303 20.8308 5.4725 18.9464C4.69197 17.0621 4.48775 14.9886 4.88566 12.9881C5.28357 10.9877 6.26574 9.15019 7.70797 7.70796C9.1502 6.26573 10.9877 5.28356 12.9881 4.88565C14.9886 4.48774 17.0621 4.69196 18.9464 5.47249C20.8308 6.25302 22.4414 7.5748 23.5745 9.27068C24.7077 10.9666 25.3125 12.9604 25.3125 15C25.3094 17.7341 24.2219 20.3553 22.2886 22.2886C20.3553 24.2219 17.7341 25.3094 15 25.3125ZM17.5383 10.9758L13.5129 15L17.5383 19.0242C17.6254 19.1113 17.6945 19.2147 17.7416 19.3285C17.7888 19.4423 17.813 19.5643 17.813 19.6875C17.813 19.8107 17.7888 19.9327 17.7416 20.0465C17.6945 20.1603 17.6254 20.2637 17.5383 20.3508C17.4512 20.4379 17.3478 20.507 17.234 20.5541C17.1202 20.6013 16.9982 20.6255 16.875 20.6255C16.7518 20.6255 16.6298 20.6013 16.516 20.5541C16.4022 20.507 16.2988 20.4379 16.2117 20.3508L11.5242 15.6633C11.4371 15.5762 11.3679 15.4728 11.3207 15.359C11.2736 15.2452 11.2493 15.1232 11.2493 15C11.2493 14.8768 11.2736 14.7548 11.3207 14.641C11.3679 14.5272 11.4371 14.4238 11.5242 14.3367L16.2117 9.64922C16.2988 9.56212 16.4022 9.49302 16.516 9.44588C16.6298 9.39874 16.7518 9.37448 16.875 9.37448C16.9982 9.37448 17.1202 9.39874 17.234 9.44588C17.3478 9.49302 17.4512 9.56212 17.5383 9.64922C17.6254 9.73632 17.6945 9.83973 17.7416 9.95353C17.7888 10.0673 17.813 10.1893 17.813 10.3125C17.813 10.4357 17.7888 10.5577 17.7416 10.6715C17.6945 10.7853 17.6254 10.8887 17.5383 10.9758Z",
                                fill: "#EAEAEA"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("h1", { staticClass: "page-title ml-3" }, [
                          _vm._v(_vm._s(_vm.$t("autorisation.Notifs")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("h1", { staticClass: "page-title d-none d-md-block" }, [
                      _vm._v(_vm._s(_vm.$t("autorisation.Params")))
                    ])
                  ]
                )
              ])
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2 d-none d-md-block",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Close")))]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v(_vm._s(_vm.$t("notif.enable.disable")))]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
            _c(
              "div",
              { staticClass: "permission-toggle" },
              [
                _c(
                  "label",
                  {
                    staticClass: "permission-label mr-3",
                    attrs: { for: "myAnnoncesNotifications" }
                  },
                  [_vm._v(_vm._s(_vm.$t("notif.myAnnoncesNotifications")))]
                ),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  attrs: {
                    size: "lg",
                    id: "myAnnoncesNotifications",
                    switch: ""
                  },
                  model: {
                    value: _vm.notif.myAnnoncesNotifications.value,
                    callback: function($$v) {
                      _vm.$set(_vm.notif.myAnnoncesNotifications, "value", $$v)
                    },
                    expression: "notif.myAnnoncesNotifications.value"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
            _c(
              "div",
              { staticClass: "permission-toggle" },
              [
                _c(
                  "label",
                  {
                    staticClass: "permission-label mr-3",
                    attrs: { for: "myDiscoveriesNotifications" }
                  },
                  [_vm._v(_vm._s(_vm.$t("notif.myDiscoveriesNotifications")))]
                ),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  attrs: {
                    size: "lg",
                    id: "myDiscoveriesNotifications",
                    switch: ""
                  },
                  model: {
                    value: _vm.notif.myDiscoveriesNotifications.value,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.notif.myDiscoveriesNotifications,
                        "value",
                        $$v
                      )
                    },
                    expression: "notif.myDiscoveriesNotifications.value"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
            _c(
              "div",
              { staticClass: "permission-toggle" },
              [
                _c(
                  "label",
                  {
                    staticClass: "permission-label mr-3",
                    attrs: { for: "myAlertsNotifications" }
                  },
                  [_vm._v(_vm._s(_vm.$t("notif.myAlertsNotifications")))]
                ),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  attrs: {
                    size: "lg",
                    id: "myAlertsNotifications",
                    switch: ""
                  },
                  model: {
                    value: _vm.notif.myAlertsNotifications.value,
                    callback: function($$v) {
                      _vm.$set(_vm.notif.myAlertsNotifications, "value", $$v)
                    },
                    expression: "notif.myAlertsNotifications.value"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
            _c(
              "div",
              { staticClass: "permission-toggle" },
              [
                _c(
                  "label",
                  {
                    staticClass: "permission-label mr-3",
                    attrs: { for: "newAnnoncesCloseNotifications" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("notif.newAnnoncesCloseNotifications"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  attrs: {
                    size: "lg",
                    id: "newAnnoncesCloseNotifications",
                    switch: ""
                  },
                  model: {
                    value: _vm.notif.newAnnoncesCloseNotifications.value,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.notif.newAnnoncesCloseNotifications,
                        "value",
                        $$v
                      )
                    },
                    expression: "notif.newAnnoncesCloseNotifications.value"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
            _c(
              "div",
              { staticClass: "permission-toggle" },
              [
                _c(
                  "label",
                  {
                    staticClass: "permission-label mr-3",
                    attrs: { for: "lampionsNotifications" }
                  },
                  [_vm._v(_vm._s(_vm.$t("notif.lampionsNotifications")))]
                ),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  attrs: {
                    size: "lg",
                    id: "lampionsNotifications",
                    switch: ""
                  },
                  model: {
                    value: _vm.notif.lampionsNotifications.value,
                    callback: function($$v) {
                      _vm.$set(_vm.notif.lampionsNotifications, "value", $$v)
                    },
                    expression: "notif.lampionsNotifications.value"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cf44026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cf44026","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NotifParamModal.vue
// module id = AIer
// module chunks = 0